import { useTranslation } from "react-i18next";

type Props = {
  exerciseExists: boolean;
  onSaveAnyway: () => void;
  onAddModel: () => void;
  onBack: () => void;
};

// A yes/no question leaves the author with nothing to do after "no": the form is unchanged
// and the next click is the same save button. The three ways out are named instead.
export const ModelMissingDialog = (props: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={props.onBack}></div>
      <div className="modal-card" style={{ width: "min(44rem, 92vw)", height: "auto" }}>
        <header className="modal-card-head">
          <p className="modal-card-title">{t("noInputModelTitle")}</p>
          <button className="delete" aria-label="close" onClick={props.onBack}></button>
        </header>
        <section className="modal-card-body">
          <p>{t("noInputModelDialogText")}</p>
          <p className="mt-2">{t(props.exerciseExists ? "exerciseCreatedForModel" : "exerciseCreatedOnSave")}</p>
        </section>
        <footer className="modal-card-foot" style={{ flexWrap: "wrap", gap: "0.5rem" }}>
          <button className="button is-success" onClick={props.onSaveAnyway}>
            {t("saveWithoutModel")}
          </button>
          <button className="button is-primary" onClick={props.onAddModel}>
            {t("addModelNow")}
          </button>
          <button className="button" onClick={props.onBack}>
            {t("backToForm")}
          </button>
        </footer>
      </div>
    </div>
  );
};
